// all mutations should be by companyID
import Vue from 'vue';

import {byID, bySymbol} from '../common'

export default {
    addPortfolioSymbol (state, sym) {
        state.items.push(sym);

    },
    removePortofolioSymbol (state, payload) {
        byID(state, payload, (index)=>
            state.items.splice(index, 1)


        );
    },
    updatePortfolioSymbolFields (state, payload) {
        byID(state, payload, (index)=>
            Vue.set(state.items, index, {...state.items[index], ...payload.update})
        );
    },
    updateMonthFields (state, payload) {
        byID(state, payload, (index)=>
            Vue.set(state.items, index, {...state.items[index], ...payload.update})
        );
    },
    updateDailyFields (state, payload) {
        byID(state, payload, (index)=>
            Vue.set(state.items, index, {...state.items[index], ...payload.update})
        );
    },
    updateRealtimeFields (state, payload) {
        byID(state, payload, (index)=>
            Vue.set(state.items, index, {...state.items[index], ...payload.update})
        );
    },
    insertLoadedPortfolio(state, payload){
        state.items = payload;
    },
    appendLog(state, payload){
        const old = state.log ? state.log: '';
        state.log = old + '<br/>' + '<span class="portfolio_log_'+ payload.level+'">'+payload.message+'</span>';
    },
    clearLog(state){
        state.log = '';
        state.notified_tb_login = false;
    },
    setPortfolioSymbolsLoad(state, payload){
        state.loadingPortfolioSymbols = payload;
        
    },
    setRowPredictionLoading(state, payload){
        byID(state, payload, (index)=>{
            Vue.set(state.rowPredictionLoading, index, true);    
        });
    },
    setAllPredictionsLoaded(state){
        state.rowPredictionLoading = [state.items.length];
        state.selectedItems = [state.items.length];
        for (let i = 0; i<state.items.length; i++) {
            Vue.set(state.rowPredictionLoading, i, false);

        }
    },
    setAllPredictionsLoading(state){
        state.rowPredictionLoading = state.items.map(o=> true);
        //state.colored = state.items.map(o=> '');
        state.rowPredictionLoading = [];
        for (let i = 0; i<state.items.length; i++) {
            Vue.set(state.rowPredictionLoading, i, true);
            //Vue.set(state.colored, i, '');
        }
    },
    setRowPredictionLoaded(state, payload){
        byID(state, payload, (index)=>{
            Vue.set(state.rowPredictionLoading, index, false);
        });
    },
    setColoredRow(state, payload){
        Vue.set(state.colored, payload.index, payload.color);
    },
    setRefreshing(state, payload){
        state.refreshing = payload;
    },
    setLoadingQuotes(state, payload){
      state.loadingQuotes = payload;
    },
    setTimer(state, payload){
        state.timer = payload;
    },
    selectEditSymbol(state, payload) {
      state.selectedForEdit = payload;
    },
  // multiselect
    toggleItemSelectProp(state, payload){
      byID(state, payload, (index)=> {
        const update =   {selected: !state.items[index].selected}
        Vue.set(state.items, index, {...state.items[index], ...update});
      });
    },
    selectedAll(state, payload){
      for (let i = 0; i<state.items.length; i++) {
        Vue.set(state.items, i, {...state.items[i], selected: true});
      }
       // state.items = state.items.map(o=> {o.selected = true; return o;});
    },
    unselectedAll(state, payload) {
      for (let i = 0; i<state.items.length; i++) {
        Vue.set(state.items, i, {...state.items[i], selected: false});
      }
      //state.items = state.items.map(o=> {o.selected = false; return o;});
    },

  HideBatchForm(state, payload) {
        state.showBatchPlaceForm = false;
  },
  SetBatchLimitSource(state, payload) {
        state.BatchLimitSource = payload;
  },
  SetBatchAllocated(state, payload) {
        state.BatchAllocated = payload;
  }
    
}
